import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

function TemperatureEquipment({ profile, name }) {
  const { t } = useTranslation();
  return (
    <>
      <Grid item xs={12} style={{ marginTop: 10 }}>
        <Typography>{name}</Typography>
      </Grid>
      <Grid
        item
        xs={6}
        style={{ textAlign: 'right', paddingRight: 10, marginTop: 10 }}
      >
        <Typography>{t('commodities.minimumTemperature')}</Typography>
      </Grid>
      <Grid item xs={6} style={{ marginTop: 10, color: 'grey' }}>
        <Typography>
          {profile.holdingMinC}°C / {profile.holdingMinF}°F
        </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        style={{ paddingRight: 10, textAlign: 'right', marginTop: 10 }}
      >
        <Typography>{t('commodities.maximumTemperature')}</Typography>
      </Grid>
      <Grid
        item
        xs={6}
        style={{ marginTop: 10, color: 'grey', marginBottom: 10 }}
      >
        <Typography>
          {profile.holdingMaxC}°C / {profile.holdingMaxF}°F
        </Typography>
      </Grid>
    </>
  );
}

export default TemperatureEquipment;
